module.exports = __webpack_public_path__ + "static/media/calculator-2-thumbnail.3decdac0.png";